module.exports = __webpack_public_path__ + "img/banner-pagina.a11177cc.jpg";